import { useAuth } from '../context/AuthContext';
import LoginDialog from '../components/LoginDialog';
import { useNavigate } from 'react-router-dom';

export default function RequireRole({ role, children }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (user && user.role === role) {
    return children;
  }

  return (
    <div className="min-h-screen bg-[#FAFCFE] flex items-center justify-center">
      <LoginDialog
        open={true}
        requiredRole={role}
        onGoHome={() => navigate('/')}
      />
    </div>
  );
}
